import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-box game-edit" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1)
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "website" }, "Website", -1)
const _hoisted_9 = { class: "field field-select" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "store" }, "Type", -1)
const _hoisted_11 = { class: "buttons" }
const _hoisted_12 = ["textContent"]

import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { Store, StoreType } from '@/models/store.model';
import Choice, { Item } from '@/components/choice/Choice.vue';
import { computed, onMounted, reactive, ref } from 'vue';
import { Actions, Mutations } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreEdit',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const item = reactive<Store>(new Store());
const isEdit = ref<boolean>(false);
const types = ref<Item[]>([
  {
    value: StoreType.GameStore,
    label: 'Game',
  },
  {
    value: StoreType.HardwareStore,
    label: 'Hardware',
  },
  {
    value: StoreType.GenericStore,
    label: 'Generic',
  },
]);

const action = computed<string>(() => {
  return isEdit.value ? 'Edit' : 'Add';
});
const title = computed<string>(() => {
  return action.value + ' store item';
});

onMounted(async () => {
  if (~route.path.indexOf('edit') && !store.state.item) {
    // on reload
    isEdit.value = true;
    store
      .dispatch(Actions.GetStoreByID, parseInt(`${route.params.id}`, 10))
      .then((i) => {
        Object.assign(item, i);
      });
  } else if (store.state.item) {
    // on edit from another page
    isEdit.value = true;
    Object.assign(item, store.state.item);
  } else {
    // get all items
    store.dispatch(Actions.GetStores);
    Object.assign(item, new Store());
  }
});

const cancel = () => {
  store.commit(Mutations.SetViewItem, null);
  router.push('/stores');
};

const submit = async () => {
  if (item.isValid()) {
    const response = await store.dispatch(Actions.UpdateStore, {
      item: item,
      edit: isEdit.value,
    });
    if (response) {
      cancel();
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", {
      textContent: _toDisplayString(_unref(title))
    }, null, 8, _hoisted_2),
    item
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(submit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              name: "name",
              autofocus: "",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.name) = $event))
            }, null, 512), [
              [_vModelText, item.name]
            ]),
            (!item.isValid('name'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(item.validation.messages['name'])
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "website",
              name: "website",
              autofocus: "",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.website) = $event))
            }, null, 512), [
              [_vModelText, item.website]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(Choice, {
              modelValue: item.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.type) = $event)),
              id: "type",
              items: types.value
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              class: "cancel",
              onClick: cancel
            }, "Cancel"),
            _createElementVNode("button", {
              type: "submit",
              textContent: _toDisplayString(_unref(action))
            }, null, 8, _hoisted_12)
          ])
        ], 40, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})